import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { SoldServicesIcon } from '../SoldServicesIcon'
import { soldServiceStatusText } from '../utils/soldServiceStatusText'
import { currencyString } from '@sales-center/common'

interface Props {
  soldServiceStatus: SOLD_SERVICE_STATUS
  count: number
  onManageClick: () => void
  value: number
}

const getStyles = (theme: Theme) => ({
  card: {
    '&:not(:last-child)': {
      marginRight: theme.spacing(1.5),
    },
    padding: theme.spacing(1),
    width: '160px',
    height: '160px',
  },

  count: {
    fontFamily: 'Source Sans Pro',
    fontSize: '21px',
  },

  header: { marginBottom: theme.spacing(1) },

  link: {
    color: '#005aa3',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
  },

  linkContainer: {
    marginTop: theme.spacing(2),
  },

  statusName: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
    fontWeight: 500,
  },

  value: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
  },
})

export const SoldServicesStatusSummaryCard: FC<Props> = (props) => {
  const { count, onManageClick, soldServiceStatus, value } = props

  const statusText = soldServiceStatusText(soldServiceStatus)
  const styles = getStyles(useTheme())
  return (
    <Card sx={styles.card}>
      <Box sx={styles.header}>
        <SoldServicesIcon status={soldServiceStatus} width={24} />
        <span style={styles.statusName}>{statusText}</span>
      </Box>
      <Box sx={styles.count}>{count}</Box>
      <Box sx={styles.value}>{`$${currencyString(value)}`}</Box>
      <Box sx={styles.linkContainer}>
        <Button
          variant="text"
          disabled={!count}
          sx={styles.link}
          onClick={onManageClick}
        >
          Manage
        </Button>
      </Box>
    </Card>
  )
}
